export interface IIntegration {
  id: string;
  type: string;
  category: Category;
  configuration: Configuration;
  syncStatus: unknown;
  state: State;
  createdDate: Date;
  modifiedDate: Date;
  createdBy: CreatedBy;
}

export interface Category {
  id: string;
  name: string;
  fliteView: boolean;
}

export interface Configuration {
  userId: string;
  accountId: string;
  baseUri: string;
}

export interface State {
  code: string;
  message: unknown;
}

export interface CreatedBy {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface DocusignEnvelopeSender {
  userName?: string;
  email?: string;
  userId?: string;
  accountId?: string;
}

export interface DocusignEnvelopeRecipient {
  recipientId?: string;
  recipientType?: string;
  roleName?: string;
  name?: string;
  email?: string;
  clientUserId?: string;
  status?: string;
  routingOrder?: string;
}

export interface DocusignEnvelope {
  id?: string;
  integrationId?: string;
  dealRoomId?: string;
  envelopeId?: string;
  emailSubject?: string;
  status?: string;
  envelopeCreatedDateTime?: string;
  lastModifiedDateTime?: string;
  deliveredDateTime?: string;
  sentDateTime?: string;
  completedDateTime?: string;
  statusChangedDateTime?: string;
  sender?: DocusignEnvelopeSender;
  recipients?: DocusignEnvelopeRecipient[];
}

export const SIGNING_COMPLETE_SOURCE = 'paperflite-docusign';
export const SIGNING_COMPLETE_TYPE = 'recipient-view-complete';
